import { render, staticRenderFns } from "./shouru.vue?vue&type=template&id=2edfa352&scoped=true&"
import script from "./shouru.vue?vue&type=script&lang=js&"
export * from "./shouru.vue?vue&type=script&lang=js&"
import style0 from "./shouru.vue?vue&type=style&index=0&id=2edfa352&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edfa352",
  null
  
)

export default component.exports